'use strict'

import { DataHandler } from './util';

export default class Contact {
    constructor() {
        this.content = $('.contentContact');
        this.createEvents();
        this.bgColor = $('.contentContact').css('background-color');
        this.hide();
        this.attempt = false;
    }
    createEvents() {
        $('.questions > p').click(() => {
            window.staticEvents.emit('navigate','contact');
        });
        $('#contactMessage').bind('input propertychange', () => {
            if ($('#contactMessage')[0].value.length > 0) {
                if (!this.attempt) {
                    window.staticEvents.emit('trackEvent',['contact','mail','started writing']);
                    this.attempt = true;
                }
                $('#contactSubmit').parent().not('.active').addClass('active');
            } else {
                $('#contactSubmit').parent().removeClass('active');
            }
        });
        $('#contactSubmit').click((e) => {
            const json = {
                "clientName":$('#clientName').val(),
                "clientMail":$('#clientMail').val(),
                "message":$('#contactMessage').val()
            };
            const send = JSON.stringify(json);
            if ($('#clientName').val().length > 2 && $('#clientMail').val().length > 2) {
                if (this.validateEmail($('#clientMail').val())) {
                    DataHandler.request('../php/sendmail.php?send=' + send, this.success);
                } else {
                    DataHandler.request('../php/mailFailure.php?send=' + send,()=>{});
                    window.staticEvents.emit('trackEvent',['contact','mail','fail invalid email']);
                }
            } else {
                alert('Bitte alle Daten angeben, damit ich Sie erreichen kann.');
            }
        });
    }
    hide() {
        this.content.find('.active').removeClass('active');
        this.content.detach();
    }
    show() {
        this.content.insertBefore('.questions');
        this.content.find('.active').removeClass('active');
        this.content[0].style.display = 'flex';
        //$('.contentContact').css('background-color','white');
    }
    success(data) {
        if (data === "success") {
            window.staticEvents.emit('trackEvent',['contact','mail','sent successfully']);
            $('.ks_respond.success').addClass('active');
            $('#clientName').val('');
            $('#clientMail').val('');
            $('#contactMessage').val('');
            setTimeout((e) => {
                $('.ks_respond.success').removeClass('active');
            },2000);
        } else {
            window.staticEvents.emit('trackEvent',['contact','mail','fail on server']);
            $('.ks_respond.fail').addClass('active');
            setTimeout((e) => {
                $('.ks_respond.fail').removeClass('active');
            },2000);
        }
    }
    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}
